import { Icon, IconSize, Typography, Next } from '@shipengine/giger';
import { IconNames } from '@shipengine/giger-theme';
import { getBenefitsListStyles, getBenefitItemStyles, getBenefitIconStyles, getBenefitTextStyles, getLinkStyles } from './InsuranceCardInfoStyles.js';
import { useTranslation } from '@packlink/translation-provider';
import { useHelpCenter, HELP_CENTER_KEYS } from '@packlink/provider';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';

const InsuranceCardInfo = _ref => {
  let {
    amount,
    benefitsList,
    showLink = false
  } = _ref;
  const getHelpCenterPage = useHelpCenter();
  const {
    t
  } = useTranslation();
  return jsxs(Fragment, {
    children: [jsx("ul", {
      css: getBenefitsListStyles,
      children: benefitsList.map((benefit, index) => {
        return jsxs("li", {
          css: getBenefitItemStyles,
          children: [jsx(Icon, {
            name: IconNames.CHECK,
            size: IconSize.SIZE_SMALL,
            css: getBenefitIconStyles
          }), jsx(Typography, {
            variant: "small",
            css: getBenefitTextStyles,
            children: t(benefit, {
              amount: amount
            })
          })]
        }, index);
      })
    }), showLink && jsxs(Next.Link, {
      href: getHelpCenterPage(HELP_CENTER_KEYS.insurance),
      target: "_blank",
      css: getLinkStyles,
      children: [jsx(Icon, {
        name: IconNames.SHIELD,
        size: IconSize.SIZE_SMALL
      }), jsx(Typography, {
        variant: "body2",
        bold: true,
        children: t('insurance-selector.insurance-card.link')
      })]
    })]
  });
};

export { InsuranceCardInfo };
//# sourceMappingURL=InsuranceCardInfo.js.map
